import data from "../../.sourceflow/branches.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const offices_helper = new CollectionHelper(data);
